import { render, staticRenderFns } from "./BookingRateModal.vue?vue&type=template&id=5178bb98&"
import script from "./BookingRateModal.vue?vue&type=script&lang=js&"
export * from "./BookingRateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports